import type { FieldType, OperatorOptions, TypeInstanceMap } from '@lighthouse/core'

export const JoinFieldIconColor = 'var(--color-green-500)'

export const JoinDataSourceDisableInnerType: TypeInstanceMap[] = ['RICH_TEXT']

export const MatchEnableInnerType: TypeInstanceMap[] = ['TEXT', 'NUMBER', 'DATE', 'BOOL', 'ARRAY']

export const JoinCureText: FieldType[] = ['text', 'url', 'email', 'phoneNumber', 'id', 'department']

export const innerTypeNameMap: Record<TypeInstanceMap, string> = {
    NUMBER: '数值',
    TEXT: '文本',
    DATE: '时间',
    BOOL: '布尔',
    ARRAY: '数组',
    RICH_TEXT: '富文本',
    NULL: '空',
    RUNTIME: '空'
}

export const textJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '等于',
        value: '='
    },
    {
        label: '不等于',
        value: '!='
    },
    {
        label: '包含',
        value: 'contains'
    },
    {
        label: '不包含',
        value: 'notContains'
    },
    {
        label: '被包含',
        value: 'containedBy'
    },
    {
        label: '开头为',
        value: 'startWith'
    },
    {
        label: '结尾为',
        value: 'endWith'
    },
    {
        label: '为空',
        value: 'isEmpty'
    },
    {
        label: '不为空',
        value: 'isNotEmpty'
    }
]

export const numberJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '=',
        value: '='
    },
    {
        label: '≠',
        value: '!='
    },
    {
        label: '>',
        value: '>'
    },
    {
        label: '≥',
        value: '>='
    },
    {
        label: '<',
        value: '<'
    },
    {
        label: '≤',
        value: '<='
    },
    {
        label: '为空',
        value: 'isEmpty'
    },
    {
        label: '不为空',
        value: 'isNotEmpty'
    }
]

export const dateJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '等于',
        value: '='
    },
    {
        label: '不等于',
        value: '!='
    },
    {
        label: '早于',
        value: '<'
    },
    {
        label: '晚于',
        value: '>'
    },
    {
        label: '早于等于',
        value: '<='
    },
    {
        label: '晚于等于',
        value: '>='
    },
    {
        label: '为空',
        value: 'isEmpty'
    },
    {
        label: '不为空',
        value: 'isNotEmpty'
    }
]

export const arrayJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '等于',
        value: '='
    },
    {
        label: '不等于',
        value: '!='
    },
    {
        label: '包含',
        value: 'contains'
    },
    {
        label: '被包含',
        value: 'containedBy'
    },
    {
        label: '不包含',
        value: 'notContains'
    },
    {
        label: '为空',
        value: 'isEmpty'
    },
    {
        label: '不为空',
        value: 'isNotEmpty'
    }
]

export const boolJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '是',
        value: '='
    },
    {
        label: '不是',
        value: '!='
    }
]

export const richTextJoinOperatorOptions: OperatorOptions[] = [
    {
        label: '为空',
        value: 'isEmpty'
    },
    {
        label: '不为空',
        value: 'isNotEmpty'
    }
]

export const innerTypeJoinOperatorMap: Record<TypeInstanceMap, OperatorOptions[]> = {
    TEXT: textJoinOperatorOptions,
    NUMBER: numberJoinOperatorOptions,
    DATE: dateJoinOperatorOptions,
    BOOL: boolJoinOperatorOptions,
    ARRAY: arrayJoinOperatorOptions,
    RICH_TEXT: richTextJoinOperatorOptions,
    NULL: [],
    RUNTIME: []
}
